module.exports = __webpack_public_path__ + "static/img/ic_arrow_right_purple.aab220a5.svg";